import React, { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";

import "../../Formation/ResponsableFormation/RessourcesStyles/EventManagement.css";

const initialForm = {
    absenceReason: "",
    comment: "",
};

export default function EventAbsenceModal({ open, event, loading, onClose, onSubmit }) {
    const [form, setForm] = useState(initialForm);

    useEffect(() => {
        if (!open) {
            setForm(initialForm);
        }
    }, [open]);

    if (!open || !event) return null;

    const handleSubmit = (submitEvent) => {
        submitEvent.preventDefault();
        if (!form.absenceReason.trim()) return;
        onSubmit({
            absenceReason: form.absenceReason.trim(),
            comment: form.comment.trim(),
        });
    };

    return (
        <div className="ev-modal-overlay" onClick={onClose}>
            <div className="ev-modal ev-modal--small" onClick={(eventTarget) => eventTarget.stopPropagation()}>
                <div className="ev-modal-header">
                    <h3>
                        <AlertTriangle size={16} />
                        Declarer mon absence
                    </h3>
                    <button type="button" className="ev-x" onClick={onClose}>
                        <X size={18} />
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="ev-modal-body">
                        <div className="ev-grid">
                            <div className="ev-field ev-span-2">
                                <label>Evenement</label>
                                <input value={event.titre || ""} disabled className="ev-input" />
                            </div>

                            <div className="ev-field ev-span-2">
                                <label>Motif d'absence *</label>
                                <input
                                    type="text"
                                    className="ev-input"
                                    value={form.absenceReason}
                                    onChange={(eventTarget) =>
                                        setForm((current) => ({ ...current, absenceReason: eventTarget.target.value }))
                                    }
                                    placeholder="Ex: Indisponibilite, maladie..."
                                />
                            </div>

                            <div className="ev-field ev-span-2">
                                <label>Commentaire</label>
                                <textarea
                                    className="ev-input"
                                    value={form.comment}
                                    onChange={(eventTarget) =>
                                        setForm((current) => ({ ...current, comment: eventTarget.target.value }))
                                    }
                                    placeholder="Commentaire optionnel"
                                    style={{ minHeight: 90 }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="ev-modal-footer">
                        <button type="button" className="ev-btn ev-btn-light" onClick={onClose}>
                            Annuler
                        </button>
                        <button
                            type="submit"
                            className="ev-btn ev-btn-primary"
                            disabled={loading || !form.absenceReason.trim()}
                        >
                            {loading ? "Enregistrement..." : "Declarer mon absence"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
